export default {
  Employees: "Employés",
  "Add employee": "Ajouter un employé",
  "All statuses": "Tous les statuts",
  "All employments": "Tous les types d'emploi",
  "Full-time": "Temps plein",
  "Part-time": "Temps partiel",
  Contract: "Contractuel",
  "All roles": "Tous les rôles",
  // --- employee-meta.tsx ---
  Active: "Actif",
  Inactive: "Inactif",
  Terminated: "Terminé",
  Name: "Nom",
  Email: "Email",
  Role: "Rôle",
  Status: "Statut",
  "Hire Date": "Date d'embauche",
  Actions: "Actions",

  // --- employee-form.tsx ---
  "First Name": "Prénom",
  "Last Name": "Nom de famille",
  Phone: "Téléphone",
  "Employment Status": "Statut d'emploi",
  Description: "Description",
  "Shop ID": "ID de la boutique",
  Country: "Pays",
  Address: "Adresse",
  "Date of Birth": "Date de naissance",
  "National ID": "ID national",
  "Emergency Contact": "Contact d'urgence",
  Education: "Éducation",
  Salary: "Salaire",

  // --- select-employee.tsx ---
  Employee: "Employé",
  "Search employee by name, email, role, or description":
    "Rechercher un employé par nom, email, rôle ou description",
  "Edit Selection": "Modifier la sélection",
  "No employees found": "Aucun employé trouvé",

  // --- create-employee-modal.tsx ---
  "Create a new employee": "Créer un nouvel employé",

  // --- edit-employee-modal.tsx ---
  "Edit Employee": "Modifier l'employé",

  // --- view-employee-modal.tsx & view-employee-block.tsx ---
  "General Information": "Informations générales",
  "Employment Details": "Détails de l'emploi",
  Metadata: "Métadonnées",
  "Created At": "Créé le",
  "Updated At": "Mis à jour le",
  "User ID": "ID utilisateur",
  "Related User": "Utilisateur lié",

  // --- delete-employee-modal.tsx ---
  "Do you really want to delete this Employee?":
    "Voulez-vous vraiment supprimer cet employé ?",
  "Warning: This action is irreversible and may lead to cascade deletions.":
    "Avertissement : Cette action est irréversible et peut entraîner des suppressions en cascade.",
  Cancel: "Annuler",
  "Confirm Deletion": "Confirmer la suppression",

  // --- employee-list-block.tsx ---

  // --- General ---
  Submit: "Soumettre",
  active: "actif",
  inactive: "inactif",
  terminated: "licencié",
  Manager: "Manager",
  manager: "manager",
  Seller: "Vendeur",
  seller: "vendeur",
  Owner: "Propriétaire",
  owner: "propriétaire",
  "Shop Owner": "Propriétaire de boutique",
  name: "nom",
  email: "e-mail",
  role: "rôle",
  status: "statut",
  actions: "actions",
};
